import React from 'react';
import './ExperienciasPage.css';
import Scrollytelling from './Scrollytelling';

function ExperienciasPage() {
  return (
    <div className="experiencias-page">
      <Scrollytelling />
    </div>
  );
}

export default ExperienciasPage;